var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup397(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.097,
    height: 21.096,
    viewBox: "0 0 21.097 21.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(-1122.903 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M23.223,23.222a1.319,1.319,0,0,1,1.866,0L30.165,28.3A1.319,1.319,0,0,1,28.3,30.164l-5.076-5.076a1.319,1.319,0,0,1,0-1.866Z",
    transform: "translate(1113.448 4.547)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M8.57,15.822A7.252,7.252,0,1,0,1.319,8.57,7.252,7.252,0,0,0,8.57,15.822Zm8.57-7.252A8.57,8.57,0,1,1,8.57,0a8.57,8.57,0,0,1,8.57,8.57Z",
    transform: "translate(1122.903 14)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup397);
export default __webpack_public_path__ + "static/media/Group 397.58377ffd3584dd5daf09315eb7497640.svg";
export { ForwardRef as ReactComponent };